// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vant from "vant";
import "vant/lib/index.css";
import TIMELIST from '../utils/timeList'
import FACELIST from '../utils/faceList'
import http from "../utils/http";
import global from "../utils/global";
import WITSBOX_ENV_PARAM from "../utils/common";
import i18n from "./lang"; //语言包
import "../utils/rem.js";
import throttle from "../utils/throttle.js";
import store from '../store/index'
// import 'babel-polyfill'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Es6Promise from "es6-promise";
require("es6-promise").polyfill();
Es6Promise.polyfill();
// 注册loading指令
Vue.directive('loading', {
  update: function (el, binding) {
    if (binding.value) {
      document.querySelector('.loading-box').style.display = ''
    } else {
      document.querySelector('.loading-box').style.display = 'none'
    }
  },
})
Vue.config.productionTip = false;

Vue.config.productionTip = false;
Vue.use(Vant);

Vue.prototype.request = http;
Vue.prototype.global = global;
Vue.prototype.throttle = throttle;
Vue.prototype.TIMELIST = TIMELIST
Vue.prototype.WITSBOX_ENV_PARAM = WITSBOX_ENV_PARAM;
Vue.prototype.FACELIST = FACELIST
// 全局引入toast
import { Toast, Dialog } from "vant";
Vue.prototype.Toast = Toast;
Vue.prototype.Dialog = Dialog;
Vue.use(Viewer, {
  defaultOptions: {
    button: false,
    navbar: false,
    title: false,
    toolbar: true
  }
})

import textFormat from "../utils/textFormat";
Vue.use(textFormat);

/* eslint-disable no-new */
new Vue({
    el: "#app",
    i18n,
    router,
    store,
    components: { App },
    data: {
        Bus: new Vue(),
      },
      render: (h) => h(App),
});




// WEBPACK FOOTER //
// ./src/main.js